import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/process-session", { session_id: sessionId });
        setToken(data.token);
        await refresh();
        toast.success("Signed in with Google");
        if (data.user.is_admin) navigate("/admin", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen bg-[var(--rg-bg)] text-[var(--rg-text-strong)] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-[var(--rg-sage)] animate-spin mx-auto mb-3" />
        <div className="text-[var(--rg-text)]">Completing Google sign-in...</div>
      </div>
    </div>
  );
}
